var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityThreats = function SvgSecurityThreats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.467,
    height: 57
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.71 7.536a31 31 0 0 1-7.92-1.821A31 31 0 0 1 25.29.9a4.084 4.084 0 0 0-5.117 0 31 31 0 0 1-8.5 4.815 31 31 0 0 1-7.92 1.821 4.124 4.124 0 0 0-3.756 4.112v20.43a22.61 22.61 0 0 0 12.57 20.332l8.314 4.158a4.1 4.1 0 0 0 1.847.431 4.2 4.2 0 0 0 1.849-.431l8.317-4.159a22.62 22.62 0 0 0 12.571-20.331v-20.43a4.12 4.12 0 0 0-3.756-4.112Zm-9.237 16.971L22.14 35.023a2.06 2.06 0 0 1-1.472.617h-.005a2.05 2.05 0 0 1-1.475-.625l-6.2-6.385a2.066 2.066 0 1 1 2.965-2.878l4.728 4.871 8.85-9.007a2.067 2.067 0 0 1 2.947 2.9Z",
    "data-name": "Path 44844"
  })));
};
export default SvgSecurityThreats;